import { Actions, ActionTypes } from './actions';
import { initialState, ChecklistState } from './state';

export function checklistReducer(state = initialState, action: Actions): ChecklistState {
  switch (action.type) {
    case ActionTypes.GET_CHECKLIST:
      return {
        ...state,
        loader: action.loader,
      };
    case ActionTypes.GET_CHECKLIST_FAILURE:
      return {
        ...state,
        loader: false,
        checklistItems: null,
      };
    case ActionTypes.GET_CHECKLIST_SUCCESS:
      return {
        ...state,
        checklistItems: action.payload,
        loader: false,
      };
    case ActionTypes.GET_CHECKLIST_TEMPLATE_REQUEST:
      return {
        ...state,
        loader: action.loader,
      };
    case ActionTypes.GET_CHECKLIST_TEMPLATE_SUCCESS:
      return {
        ...state,
        checklistTemplate: action.payload,
        loader: false,
      };
    case ActionTypes.GET_SHARED_CHECKLIST_TEMPLATE_REQUEST:
      return {
        ...state,
        loader: action.loader,
      };
    case ActionTypes.GET_SHARED_CHECKLIST_TEMPLATE_SUCCESS:
      return {
        ...state,
        shardchecklistTemplate: action.payload,
        loader: false,
      };
    case ActionTypes.SET_CHECKLIST_TEMPLATE_NULL:
      return {
        ...state,
        loader: false,
        checklistItems: null,
      };
    default: {
      return state;
    }
  }
}
